import angular from 'angular';
import ContactUsComponent from './contact-us-component';

export default angular.module('contact-us', []).component('contactUs', new ContactUsComponent());



// WEBPACK FOOTER //
// ./src/modules/contact/components/contact-us/contact-us-module.js